import { Section, renderRich } from "./shared";

function ImportanceChip({ importance }) {
  const isMust = Number(importance) >= 3;
  return (
    <span
      className={`font-mono text-[9px] uppercase tracking-widest px-1.5 py-0.5 border ${
        isMust
          ? "bg-black text-[#BFDBFE] border-black"
          : "bg-white text-black border-black/40"
      }`}
    >
      {isMust ? "Must know" : "Important"}
    </span>
  );
}

function CoreConceptRow({ item, regex }) {
  return (
    <li className="group flex items-start gap-3 py-2 border-b border-black/10 last:border-b-0">
      <ImportanceChip importance={item.importance} />
      <p className="flex-1 text-sm leading-relaxed">
        <span className="highlighter-inline">{renderRich(item.text, regex)}</span>
      </p>
    </li>
  );
}

export function KeyPointsSection({ concepts, regex }) {
  if (!concepts?.length) return null;
  return (
    <Section label="Key Points">
      <ul className="border-t border-black/10">
        {concepts
          .filter((c) => c && (c.text || typeof c === "string"))
          .map((c, i) => (
            <CoreConceptRow
              key={i}
              item={typeof c === "string" ? { text: c, importance: 2 } : c}
              regex={regex}
            />
          ))}
      </ul>
    </Section>
  );
}
